import { render, staticRenderFns } from "./cursorPointer.vue?vue&type=template&id=ed81a338&scoped=true"
import script from "./cursorPointer.vue?vue&type=script&lang=js"
export * from "./cursorPointer.vue?vue&type=script&lang=js"
import style0 from "./cursorPointer.vue?vue&type=style&index=0&id=ed81a338&prod&lang=scss"
import style1 from "./cursorPointer.vue?vue&type=style&index=1&id=ed81a338&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed81a338",
  null
  
)

export default component.exports